import { AppStateStore } from './AppState.store'
import { OnboardingStateStore } from './Onboarding.store'
import { RouterStateStore } from './Router.store'
import { TranslationsStore } from './Translations.store'

export class RootStore {
  AppState: AppStateStore
  TranslationsState: TranslationsStore
  Router: RouterStateStore
  OnboardingState: OnboardingStateStore

  constructor() {
    this.AppState = new AppStateStore(this)
    this.TranslationsState = new TranslationsStore(this)
    this.Router = new RouterStateStore(this)
    this.OnboardingState = new OnboardingStateStore(this)
  }
}

export const rootStore = new RootStore()
